import { useStreamingFeatureCollection } from './useStreamingFeatureCollection';
import { useStreamingVehiclesFeatureCollection } from './useStreamingVehiclesFeatureCollection';
import { streams } from '@/utils/config';

export function useStreamingFeatureCollections(search, sort, filter) {
  const featureCollections = {
    externalVehicles: useStreamingFeatureCollection(
      'external/vehicles',
      search.externalVehicles,
      sort.externalVehicles,
      filter.externalVehicles,
      streams.includes('externalVehicles'),
    ),
    externalPeople: useStreamingFeatureCollection(
      'external/people',
      search.externalPeople,
      sort.externalPeople,
      filter.externalPeople,
      streams.includes('externalPeople'),
    ),
    vehicles: useStreamingVehiclesFeatureCollection(
      search.vehicles,
      sort.vehicles,
      filter.vehicles,
      streams.includes('vehicles'),
    ),
  };

  return {
    featureCollections: streams.reduce(
      (collections, key) => ({
        ...collections,
        [key]: featureCollections[key],
      }),
      {},
    ),
    filterValues: streams.reduce(
      (values, key) => ({
        ...values,
        [key]: {},
      }),
      {},
    ),
  };
}
